export const apiHost = process.env.REACT_APP_API_HOST || '';

export const appHost = process.env.REACT_APP_HOST || '';

export const proxyHost = process.env.REACT_APP_PROXY_HOST || '';

export const sentryDNS = process.env.REACT_APP_SENTRY_DNS;

export const webappHost = process.env.REACT_APP_WEBAPP_HOST || '';

export const allowedSocialLogin = process.env.REACT_APP_ALLOWED_SOCIAL_LOGIN;

export const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;

export const nodeEnv = process.env.REACT_APP_NODE_ENV;

export const isProductionEnv = process.env.NODE_ENV === 'production';
